import FileField from "../../components/FileField";

const MB = 1024 * 1024;
const MAX_FILES = 5;
const MAX_FILE_SIZE = 5 * MB;
const MAX_TOTAL_SIZE = 20 * MB;

const uploadTypes = [
  { collection: "won", field: "won_pdf", title: "WON", description: "Add the WON documents used to prepare this worksite pack." },
  { collection: "whiteboard", field: "whiteboard_pdf", title: "Whiteboard packs", description: "Add whiteboard or supporting planning packs for the worksite." },
  { collection: "other", field: "other_pdf", title: "Other documents", description: "Add any other PDF documents needed alongside the pack." },
];

const Uploads = ({ error, media = [], onFilesChange, onOpenFile, saving = false, toBeUploaded = {} }) => {
  return (
    <div className="wsm-uploads-step">
      <div className="wsm-uploads-step__intro">
        <h3>Supporting documents</h3>
        <p>Add the PDFs required for this pack. You can add up to five files in each section.</p>
        {error && <p className="wsm-field__error" role="alert">{error}</p>}
      </div>
      <div className="wsm-uploads-step__sections">
        {uploadTypes.map((type) => {
          const existingFiles = media.filter((file) => file.collection === type.collection);
          const queuedFiles = toBeUploaded[type.field] || [];
          return (
            <section className="wsm-upload-group" key={type.collection}>
              <div className="wsm-upload-group__heading">
                <div><h4>{type.title}</h4><p>{type.description}</p></div>
                <span>{existingFiles.length + queuedFiles.length} of {MAX_FILES} files</span>
              </div>
              <FileField accept="application/pdf,.pdf" files={[...existingFiles, ...queuedFiles]}
                disabled={saving}
                helpText="PDF files only. Existing files count toward these limits." id={type.field}
                label={`Upload ${type.title.toLowerCase()}`} maxFileSizeBytes={MAX_FILE_SIZE}
                maxFiles={MAX_FILES} maxTotalSizeBytes={MAX_TOTAL_SIZE} multiple
                onChange={(files) => onFilesChange(type, files)} onOpenFile={onOpenFile} />
            </section>
          );
        })}
      </div>
    </div>
  );
};

export default Uploads;
